import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Toaster } from "react-hot-toast";

import Home from "./components/LandingPage/Home";
import GetStarted from "./components/LandingPage/GetStarted";
import ScrollToTop from "./components/LandingPage/ScrollToTop";
import BuyPlan from "./components/LandingPage/BuyPlan";
import PricingPage from "./components/LandingPage/PricingPage";
import Blogs from "./components/LandingPage/Blogs";
import Post from "./components/LandingPage/Post";
import Author from "./components/LandingPage/Author";
import AboutUs from "./components/LandingPage/AboutUS";
import PrivacyPolicy from "./components/LandingPage/PrivacyPolicy";
import TermsCondition from "./components/LandingPage/TermsCondition";
import Contact from "./components/LandingPage/ContactUs";
import IdentityPage from "./components/IdentityPage";

import Dashboard from "./components/Dashboard/Dashboard";
import ProtectedRoute from "./utils/ProtectedRoute";
import DashboardLayout from "./components/layout/DashboardLayout";
import Billing from "./features/billing/Billing";
import Ledger from "./features/billing/Ledger";
import CampaignView from "./features/whatsapp/Campaign/CampaignView";
import CampaignInsights from "./features/whatsapp/Insights";
import Campaign from "./features/whatsapp/Campaign/Campaign";
import CreateCampaign from "./features/whatsapp/Create Campaign/CreateCampaign";
import Logs from "./features/whatsapp/Logs";
import TemplateStatus from "./features/whatsapp/Template/TemplateStatus";
import TemplateView from "./features/whatsapp/Template/TemplateView";
import CreateTemplate from "./features/whatsapp/Template/CreateTemplate";
import ContactBook from "./features/whatsapp/Chats/ContactBook";
import Chats from "./features/whatsapp/Chats/Chats";
import ChatBot from "./features/whatsapp/ChatBot";
import NewCampaign from "./features/whatsapp/New Campaign/NewCampaign";
import CampaignTable from "./features/whatsapp/New Campaign/CampaignTable";
// import Developers from "./features/developers/Developer";
// import Triggers from "./features/developers/Triggers";
import ProfileDashboard from "./features/settings/ProfileDashboard";
import PlanPricing from "./features/settings/PlanPricing";
import User from "./features/settings/User";
import ProfileSetting from "./features/settings/ProfileSetting";
// import Integration from "./features/settings/Integration";
import Tickets from "./features/support/ClientSupportTickets";
import Inventory from "./features/inventory/Inventory/Inventory";
import Racks from "./features/inventory/Racks";
import Vendors from "./features/inventory/Vendors";
import GlobalInventory from "./features/inventory/Global Inventory/GlobalInventory";
import Reports from "./features/orders/Reports";
import PayOut from "./features/orders/Payout";
// import Doordash from "./features/orders/Doordash";
import Dining from "./features/orders/Dining";
import QrCode from "./features/orders/QrCode";
import Gallery from "./features/orders/Gallery";
// import SpecialOffers from "./features/orders/SpecialOffers";
// import OrderVendors from "./features/orders/OrderVendors";
import BlockUser from "./features/orders/BlockUser";
import OrderSettings from "./features/orders/Settings/OrderSettings";
import Udhari from "./features/orders/Udhari/Udhari";
import Catalogue from "./features/orders/Catalogue/Catalogue";
import Delivery from "./features/orders/Delivery";
import AddItems from "./features/orders/Catalogue/AddItems";
import IngredientsPage from "./features/orders/Catalogue/IngredientsPage";
import Order from "./features/orders/orders/Order";
import { Payments } from "./features/orders/Payment/Payments";
import SetUp from "./features/settings/SetUp";
import Onboarding from "./features/whatsapp/Onboarding";
import SellOnInstamart from "./features/inventory/Inventory/SellOnInstamart";
import Stores from "./features/inventory/Inventory/Stores";
import Banner from "./features/inventory/Inventory/Banner/Banner";
import CreateBanner from "./features/inventory/Inventory/Banner/CreateNewBanner";
import BannerLibrary from "./features/inventory/Inventory/Banner/BannerLibrary";
import HtmlEditor from "./features/inventory/Inventory/Banner/HtmlEditorComponents/HtmlEditor";
import CreatePurchase from "./features/inventory/Inventory/CreatePurchase";
import CommonComingSoon from "./utils/CommingSoon";
import PosOrderManagement from "./features/pos/Pos/Pos";
import PosOrders from "./features/pos/PosOrder/PosOrders";
import PosOrderSettings from "./features/pos/POSOrderSettings/PosSettings";
import LabelPrintingSystem from "./features/pos/Labels/LabelPrintingSystem";
// import Cuisine from "./features/orders/Cuisine";
import Payment from "./features/pos/POSOrderSettings/Payments";
// import Integration from "./features/settings/integrations/Integration";
import SpecialOffers from "./features/orders/SpecialOffer/SpecialOffers";
import OrderVendors from "./features/orders/Vendors/OrderVendors";
import Integration from "./features/pos/POSOrderSettings/integrations/Integration";

import POSOrderServices from "./components/LandingPage/POSOrderServices";
import WhatsappServices from "./components/LandingPage/WhatsappServices";
import WhatsAppOrderServices from "./components/LandingPage/WhatsappServices";
// import PosOrderServices from "./components/LandingPage/PosOrderServices";

function App() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;

    const formatTitle = (path) => {
      return path
        .split("/")
        .filter(Boolean)
        .map((word) => {
          return word
            .replace(/-/g, " ")
            .replace(/_/g, " ")
            .replace(/\b\w/g, (c) => c.toUpperCase());
        })
        .join(" | ");
    };

    let title = formatTitle(path);

    //  Special cases
    if (path === "/") {
      title = "Home";
    } else if (path.startsWith("/blogs/")) {
      title = "Blog Details";
    } else if (path.startsWith("/author/")) {
      title = "Author";
    } else if (path.startsWith("/buy-plan/")) {
      title = "Buy Plan";
    }

    document.title = `${title} | Anlook`;
  }, [location.pathname]);

  useEffect(() => {
    const scriptId = "seobix-script";

    const existingScript = document.getElementById(scriptId);

    if (existingScript) {
      existingScript.remove();
    }

    const currentRoute = location.pathname + location.search + location.hash;

    const currentPageUrl = window.location.origin + currentRoute;

    const seoScript = document.createElement("script");

    seoScript.id = scriptId;

    const params = new URLSearchParams({
      webid: "56c53e1ff4273fa3746b406c70f5bf9c",
      url: currentPageUrl,
      baseUrl: window.location.origin,
    });

    seoScript.src = `https://anlook.com/SeoBix/seo_injection.php?${params.toString()}`;

    seoScript.async = true;
    seoScript.defer = true;

    seoScript.onerror = () => {
      console.error("SeoBix failed:", currentPageUrl);
    };

    document.head.appendChild(seoScript);

    return () => {
      const script = document.getElementById(scriptId);

      if (script) {
        script.remove();
      }
    };
  }, [location.pathname, location.search, location.hash]);

  return (
    <>
      <ScrollToTop />

      <ToastContainer
        position="top-right"
        autoClose={2500}
        limit={2}
        newestOnTop
        closeOnClick={false}
        pauseOnHover={false}
        pauseOnFocusLoss={false}
        draggable={false}
        theme="light"
      />

      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000,
          style: {
            borderRadius: "12px",
            fontSize: "14px",
          },
          success: {
            iconTheme: {
              primary: "#01C37D",
              secondary: "#fff",
            },
          },
        }}
      />

      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsCondition />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/get-started" element={<GetStarted />} />
        <Route path="/buy-plan/:planId" element={<BuyPlan />} />
        <Route path="/identity" element={<IdentityPage />} />
        {/* closed due to requirement */}
        {/* <Route path="/pricing-page" element={<PricingPage />} /> */}
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blogs/:slug" element={<Post />} />
        <Route path="/author/:author" element={<Author />} />

        <Route path="/services/whatsapp" element={<WhatsappServices />} />
        <Route path="/services/pos" element={<POSOrderServices />} />
        <Route path="/services/whatsapp/" element={<WhatsAppOrderServices />} />
        <Route path="/services/pos/" element={<POSOrderServices />} />

        {/* Protected Dashboard */}
        <Route
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route path="/Dashboard" element={<Dashboard />} />
          <Route path="/WhatsApp/*" element={<Campaign />} />
          <Route path="/WhatsApp/CreateCampaign" element={<CreateCampaign />} />
          <Route path="Whatsapp/Insights" element={<CampaignInsights />} />
          <Route path="/WhatsApp/Manage1" element={<CampaignTable />} />
          <Route path="/WhatsApp/NewCampaign" element={<NewCampaign />} />
          <Route
            path="/WhatsApp/Manage/CampaignView"
            element={<CampaignView />}
          />
          <Route path="/WhatsApp/Logs" element={<Logs />} />
          <Route path="/WhatsApp/Template" element={<TemplateStatus />} />
          <Route path="/WhatsApp/TemplateView" element={<TemplateView />} />
          <Route
            path="/WhatsApp/Create-Template"
            element={<CreateTemplate />}
          />
          <Route path="/WhatsApp" element={<Chats />} />
          <Route path="/WhatsApp/ContactBook" element={<ContactBook />} />
          <Route path="/WhatsApp/ChatBot" element={<ChatBot />} />
          <Route path="/WhatsApp/Onboarding" element={<Onboarding />} />
          <Route path="/Billing/*" element={<Billing />} />
          <Route path="/Billing/Ledger" element={<Ledger />} />

          {/* <Route path="/Developer" element={<Developers />} /> */}
          {/* <Route path="/Developer/Triggers" element={<Triggers />} /> */}

          <Route path="/Profile" element={<ProfileDashboard />} />
          <Route path="/Profile/Plans" element={<PlanPricing />} />
          <Route path="/Profile/UserManagement" element={<User />} />
          <Route path="/Profile/Setting" element={<ProfileSetting />} />
          {/* <Route path="/Profile/Integration" element={<Integration />} /> */}
          <Route path="/Profile/Setup" element={<SetUp />} />

          <Route path="/Support/Tickets" element={<Tickets />} />

          <Route path="/inventory/inventory" element={<Inventory />} />
          <Route path="/inventory/racks" element={<Racks />} />
          <Route path="/inventory/vendors" element={<Vendors />} />
          <Route
            path="/inventory/sell-on-instamart"
            element={<SellOnInstamart />}
          />
          <Route
            path="/inventory/vendors/createPurchase"
            element={<CreatePurchase />}
          />
          <Route path="/inventory/global" element={<GlobalInventory />} />
          <Route path="/inventory/stores" element={<Stores />} />
          <Route path="/inventory/banner" element={<Banner />} />
          <Route
            path="/inventory/banner/create-new-banner"
            element={<CreateBanner />}
          />
          <Route
            path="/inventory/banner/banner-library"
            element={<BannerLibrary />}
          />
          <Route
            path="/inventory/banner/html-editor"
            element={<HtmlEditor />}
          />

          <Route path="/inventory/banner/*" element={<Banner />} />
          <Route path="/orders" element={<Order />} />
          <Route path="/orders/reports" element={<Reports />} />
          <Route path="/orders/payouts" element={<PayOut />} />
          {/* <Route path="/orders/Cuisine" element={<Cuisine />} /> */}
          <Route path="/orders/dinning" element={<Dining />} />
          <Route path="/orders/QR_Code" element={<QrCode />} />
          <Route path="/orders/gallery" element={<Gallery />} />
          <Route path="/orders/specialoffers" element={<SpecialOffers />} />
          <Route path="/orders/vendors" element={<OrderVendors />} />
          <Route path="/orders/blockuser" element={<BlockUser />} />
          <Route path="/orders/ordersettings" element={<OrderSettings />} />
          <Route path="/orders/credits" element={<Udhari />} />
          <Route path="/orders/catalogue" element={<Catalogue />} />
          <Route path="/orders/delivery" element={<Delivery />} />
          <Route path="/orders/payments" element={<Payments />} />
          <Route path="/orders/catalogue/add-items" element={<AddItems />} />
          <Route
            path="/orders/catalogue/edit-ingredients"
            element={<IngredientsPage />}
          />
          <Route path="/pos/pos" element={<PosOrderManagement />} />
          <Route path="/pos/orders" element={<PosOrders />} />
          <Route path="/pos/settings" element={<PosOrderSettings />} />
          <Route path="/pos/labels" element={<LabelPrintingSystem />} />
          <Route path="/pos/payments" element={<Payment />} />

          <Route path="*" element={<CommonComingSoon />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
